import * as types from './types';

const initialState = {
	default: 0
};

const percentsReducer = (state = initialState, action) => {
	const payload = action.payload;
	const type = action.type;
	switch (type) {
		case types.RUN_PERCENT: {
			return {
				...state,
				default: payload.percents
			};
		}
		case types.DEFAULT_PERCENT: {
			return initialState;
		}
		default:
			return state;
	}
};
export default percentsReducer;
